<script setup>
import { useForm } from "@inertiajs/vue3";

import VButtonSubmit from "@/Shared/Buttons/VButtonSubmit";
import VInputWithLabel from "@/Shared/Form/VInputWithLabel.vue";
import VInputReadonlyWithLabel from "@/Shared/Form/VInputReadonlyWithLabel.vue";

import VModal from "@/Shared/VModal.vue";
import { onMounted, ref } from "vue";
import Axios from "axios";
import VButton from "../../../Shared/Buttons/VButton.vue";

const props = defineProps({
    urlSendOtp: String,
    urlSubmit: String,
});

const emits = defineEmits(["onSave", "onCancel"]);

const refModal = ref(null);
const otpCode = ref(["", "", "", "", ""]);

const form = useForm({
    uuid: "",
    otp: "",
});

const sendOtp = async () => {
    const response = await Axios.post(props.urlSendOtp);
    form.uuid = response.data?.data?.uuid;
};

const submit = () => {
    form.otp = otpCode.value.join("");
    form.post(props.urlSubmit, {
        preserveScroll: true,
        forceFormData: true,
        onSuccess: () => {
            emits("onSave", form.value);
            refModal.value.closeModal();
        },
        onError: () => {
            console.log("error");
        },
    });
};

const cancel = () => {
    emits("onCancel");
};

onMounted(() => {
    sendOtp();
});
</script>

<template>
    <VModal
        ref="refModal"
        title="Stamp Document"
        size="modal-md"
        @onClose="cancel"
    >
        <template v-slot:body>
            <div class="m-3">
                <form @submit.prevent="submit">
                    <div class="row">
                        <div class="col-12 mb-3">
                            <div
                                v-if="Object.keys(form.errors).length != 0"
                                class="alert alert-danger"
                            >
                                {{ form.errors }}
                            </div>
                            <div
                                id="otp"
                                class="inputs d-flex flex-row justify-content-center mt-2"
                            >
                                <input
                                    v-model="otpCode[0]"
                                    class="m-2 text-center form-control rounded"
                                    type="text"
                                    id="first"
                                    maxlength="1"
                                />
                                <input
                                    v-model="otpCode[1]"
                                    class="m-2 text-center form-control rounded"
                                    type="text"
                                    id="second"
                                    maxlength="1"
                                />
                                <input
                                    v-model="otpCode[2]"
                                    class="m-2 text-center form-control rounded"
                                    type="text"
                                    id="third"
                                    maxlength="1"
                                />
                                <input
                                    v-model="otpCode[3]"
                                    class="m-2 text-center form-control rounded"
                                    type="text"
                                    id="fourth"
                                    maxlength="1"
                                />
                                <input
                                    v-model="otpCode[4]"
                                    class="m-2 text-center form-control rounded"
                                    type="text"
                                    id="fifth"
                                    maxlength="1"
                                />
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </template>

        <template v-slot:footer>
            <div class="text-end">
                <VButton
                    type="submit"
                    btnStyle="btn-danger"
                    :isProcessing="form.processing"
                    @onCLickSubmit="submit(0)"
                >
                    Reject
                </VButton>
                <VButtonSubmit
                    type="submit"
                    :isProcessing="form.processing"
                    @onCLickSubmit="submit(1)"
                >
                    Submit
                </VButtonSubmit>
            </div>
        </template>
    </VModal>
</template>
